import React, { Component } from 'react';

import './../../../../scss/App.scss';
import { trackingWrapper } from '../../../utils/analytics';

const NAMESPACE = '[ LandingVideo ]';

class LandingVideo extends Component {

	constructor(props){
		super(props);

		this.transitionIn = new window.TimelineMax();

		this.playBtnAnimation = new window.TimelineMax();

		this.state = {
			videoId : null,
			showVideo : false
		}

		// Tracking flags
		this.tracked10Played = false;
		// this.tracked25Played = false;
		this.tracked50Played = false;
		// this.tracked75Played = false;
		this.tracked90Played = false;
		// this.trackedPlayed = false;
		
		this.handleMediaStartedRef = this.handleMediaStarted.bind(this);
		this.handleMediaPlayingRef = this.handleMediaPlaying.bind(this);
		this.handleMediaEndedRef = this.handleMediaEnded.bind(this);
		this.handleIFrameLoaded = this.handleIFrameLoaded.bind(this);
		this.handlePlayBtnClick = this.handlePlayBtnClick.bind(this);
		this.handleMouseOver = this.handleMouseOver.bind(this);
		this.handleMouseOut = this.handleMouseOut.bind(this);
	}

	componentWillMount(){
		this.setRandomVideo();
	}

	componentDidMount(){

		window.TweenMax.set(this.refs.wipe, {"width":"100%"});

		this.transitionIn.to(this.refs.wipe, .4, {"width": "0%"})

		//

		this.playBtnAnimation.to(this.refs.playArrow, .1, {"transform":"translateX(150%)"})
		.set(this.refs.playArrow, {"transform":"translateX(-150%)"})
		.to(this.refs.playArrow, .1, {"transform":"translateX(0%)"});
	}

	componentDidUpdate(prevProps, prevState){

		if(this.props.landingTransitionOut === true && prevProps.landingTransitionOut === false){
			this.transitionIn.reverse();
		}
	}

	setRandomVideo(){

		//console.log("================ VideoOverlay :: setRandomVideo() - start pool:", window.videoAdsPool);

		// get random from pool
		let video = window.videoAdsPool[Math.floor(Math.random() * window.videoAdsPool.length)];

		// remove chosen from pool
		const newVideoAdsPool = [...window.videoAdsPool.filter(x => x !== video)];

		// if pool is empty, reset the pool with full list minus selected
		if(newVideoAdsPool.length === 0){
			window.videoAdsPool = [...window.config.videoAd.videos];

			// if total pool size is > 1, remove the selected so it does show back to back on next cycle
			if(window.config.videoAd.videos.length > 1){
				window.videoAdsPool = [...window.videoAdsPool.filter(x => x !== video)];
			}
		}
		else {
			window.videoAdsPool = [...newVideoAdsPool];
		}

		//console.log("VideoOverlay :: setRandomVideo() -  selected video: ", video);
		//console.log("VideoOverlay :: setRandomVideo() -  end pool: ", window.videoAdsPool);

		this.setState({
			videoId : video
		});
	}

	handleIFrameLoaded() {
		console.log( NAMESPACE, 'handleIFrameLoaded()' );
		window.$pdk.bind(this, true);
		window.$pdk.controller.setIFrame(this.refs.iframe, true);
		
		window.$pdk.controller.addEventListener( 'OnMediaStart', this.handleMediaStartedRef );
		window.$pdk.controller.addEventListener( 'OnMediaPlaying', this.handleMediaPlayingRef );
		window.$pdk.controller.addEventListener( 'OnMediaEnd', this.handleMediaEndedRef );
	}
	
	handleMediaStarted() {
		
		console.log( NAMESPACE, 'handleMediaStarted()' );
		
	}
	
	handleMediaPlaying( event ) {
		// console.log( NAMESPACE, 'media playing ', 'time: '+event.data.currentTime, ' duration: '+event.data.duration );
		
		let percentage = event.data.currentTime / event.data.duration;
		
		if( percentage > 0.9 && !this.tracked90Played ) {
			console.log( NAMESPACE, 'track 90% played' );
			trackingWrapper('event', 'ASgame-landing-video-play-90%', {'event_category':'america-says-game'});
			this.tracked90Played = true;
		} 
		// else if( percentage > 0.75 && !this.tracked75Played ) {
		// 	console.log( NAMESPACE, 'track 75% played' );
		// 	Krux('ns:gsn','admEvent', kruxEvents.media75Played, {});
		// 	this.tracked75Played = true;
		// } 
		else if( percentage > 0.5 && !this.tracked50Played ) {
			console.log( NAMESPACE, 'track 50% played' );
			trackingWrapper('event', 'ASgame-landing-video-play-50%', {'event_category':'america-says-game'});
			this.tracked50Played = true;
		} 
		// else if( percentage > 0.25 && !this.tracked25Played ) {
		// 	console.log( NAMESPACE, 'track 25% played' );
		// 	Krux('ns:gsn','admEvent', kruxEvents.media25Played, {});
		// 	this.tracked25Played = true;
		// } 
		else if( percentage > 0.1 && !this.tracked10Played ) {
			console.log( NAMESPACE, 'track 10% played' );
			trackingWrapper('event', 'ASgame-landing-video-play-10%', {'event_category':'america-says-game'});
			this.tracked10Played = true;
		}
	}
	
	handleMediaEnded() {
		console.log( NAMESPACE, 'handleMediaEnded()' );

		this.setState({
			showVideo : false
		});

		// turn on bg music
		window.sounds.introBg.play();
	}
	
	componentWillUnmount() {
		console.log( NAMESPACE, 'componentWillUnmount()' );
		
		window.$pdk.controller.removeEventListener( 'OnMediaStart', this.handleMediaStartedRef );
		window.$pdk.controller.removeEventListener( 'OnMediaPlaying', this.handleMediaPlayingRef );
		window.$pdk.controller.removeEventListener( 'OnMediaEnd', this.handleMediaEndedRef );
		
		window.$pdk.controller.resetPlayer();
	}

	handlePlayBtnClick() {
		this.setState({
			showVideo : true
		});

		// turn off bg music
		window.sounds.introBg.stop();
	}

	handleMouseOver(){
		this.playBtnAnimation.play();
	}

	handleMouseOut(){
		this.playBtnAnimation.reverse();
	}

	renderVideo(){
		const _this = this;

		if(this.state.showVideo){
			const iframeUrl = "https://player.theplatform.com/p/" + window.config.mpx.clientId + "/" + window.config.mpx.playerId + "/embed/select/media/" + this.state.videoId + "?form=html&autoPlay=true";

			return(
				<div className="video-player">
					<iframe ref='iframe' src={iframeUrl} width="100%" height="100%" scrolling="no" frameBorder="0" seamless="seamless" title="MPX Player" allowFullScreen onLoad={this.handleIFrameLoaded}></iframe>
				</div>
			);
		}
		else {
			return(
				<div className="poster" onClick={() => _this.handlePlayBtnClick()} onMouseOver={() => _this.handleMouseOver()} onMouseOut={() => _this.handleMouseOut()}>
					<div className="playBtn">
						<div className="playArrow" ref="playArrow"></div>
					</div>
				</div>
			);
		}
	}

	render() {
		return (
			 <div id="landingVideo">
			 	{this.renderVideo()}
		 		<div className="wipe" ref="wipe"></div>
			</div>
		);
	}
}

export default LandingVideo;



// WEBPACK FOOTER //
// ./src/js/components/landingpage/leftCol/LandingVideo.js